export const materialTabsKey = {
    MATERIALS: 'materials',
    SUPPLIERS: 'suppliers',
};

export const defaultItemsPerPage = 10;
export const defaultCurrentPage = 0;
